let routes = [
  {
    path: '/:id',
    component: () => import(/* webpackChunkName: "main" */ '../views/Product.vue'),
    name: 'product',
  }
]

export default routes;
